module.exports = __webpack_public_path__ + "assets/images/piramide-alimentar.1b6fe501.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kit-plans/piramide-alimentar.png
// module id = 790
// module chunks = 1